<template>
  <div class="flex items-center gap-x-2 group cursor-pointer">
    <div class="shrink-0 size-8 group-hover:scale-110 transition-transform relative">
      <img :src="row.iconUrl" class="size-full object-cover rounded-md shadow">
      <div class="absolute inset-y-0 right-full flex items-center mr-2">
        <EyeSlashIcon v-if="row.deletedAt" class="h-4 w-4 text-red-800" />
        <LockClosedIcon v-else-if="!row.isEnabled" class="h-4 w-4 text-black" />
      </div>
    </div>
    <div class="grow group-hover:brightness-50 truncate flex items-center gap-x-2">
      {{ row.name }}
      <div v-if="row.color" class="size-2 rounded-full" :style="{ backgroundColor: row.color }" />
    </div>
  </div>
</template>

<script setup>
import { EyeSlashIcon, LockClosedIcon } from '@heroicons/vue/24/outline';

defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});
</script>
